module.exports = __webpack_public_path__ + "static/media/shaker_05_small.5a9090bb.jpg";